import '../style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { PageStep, useReissuePassword } from './hook';
import { Toast } from 'views/mutual/toast';
import { SendSMSTemplate } from 'views/templates/sendSMS';
import { Description, labelColor, labelSize } from 'views/mutual/description';

export const ReissuePassword = () => {
  const { formik, pageStep, toastProps, certificatePage, goTopPage } = useReissuePassword();

  return (
    <>
      {pageStep === PageStep.INPUT_INFO && (
        <form onSubmit={formik.handleSubmit} className="loginsStyle">
          <div className="loginsStyle_inputs">
            <Description
              labelColor={labelColor.gray}
              labelSize={labelSize.medium}
              label="パスワード再発行手続きのため、2段階認証を行ってください"
            />
            <div className="loginsStyle_inputs_wrapper">
              <div className="loginsStyle_inputs_wrapper_label">口座番号</div>
              <div className="loginsStyle_inputs_wrapper_button">
                <input type="text" name="account" value={formik.values.account} onChange={formik.handleChange} />
              </div>
              {formik.errors.account ? <div className="errorRed">{formik.errors.account}</div> : null}
            </div>

            <div className="loginsStyle_inputs_wrapper">
              <div className="loginsStyle_inputs_wrapper_label">電話番号</div>
              <div className="loginsStyle_inputs_wrapper_button">
                <input
                  type="text"
                  name="phoneNumber"
                  placeholder="ハイフンは不要です"
                  value={formik.values.phoneNumber}
                  onChange={formik.handleChange}
                />
              </div>
              {formik.errors.phoneNumber ? <div className="errorRed">{formik.errors.phoneNumber}</div> : null}
            </div>

            <div className="loginsStyle_inputs_buttons">
              <Button
                type={ButtonType.Submit}
                label="認証コードを送信"
                buttonFill={ButtonFill.primary}
                buttonSize={ButtonSize.medium}
              />
            </div>
          </div>

          <Toast {...toastProps} />
        </form>
      )}

      {pageStep === PageStep.CERTIFIBATE && <SendSMSTemplate {...certificatePage} toastProps={toastProps} />}

      {pageStep === PageStep.FIN && (
        <div className="loginsStyle">
          <div className="loginsStyle_inputs">
            <Description
              labelColor={labelColor.gray}
              labelSize={labelSize.medium}
              label="登録されているメールアドレスに再設定パスワードをお送りしました"
            />
            <div className="loginsStyle_inputs_buttons">
              <Button
                type={ButtonType.Button}
                label="TOPへ戻る"
                buttonFill={ButtonFill.link}
                buttonSize={ButtonSize.medium}
                onClick={goTopPage}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
